import PortfolioMobile from 'components/PortfolioMobile';
import Portfolio from '../../components/Portfolio/index';
import { DataLello } from '../../components/Portfolio/data';

export default function Lello() {
  return (
    <>
      <div className="d-none d-lg-block">
        <Portfolio data={DataLello} />
      </div>
      <div className="d-block d-lg-none">
        <PortfolioMobile data={DataLello} />
      </div>
    </>
  );
}
